import { styled } from '@mui/material/styles';
import {STATUS_MODEL} from "../enums/statusEnum";
import { Radio, stepConnectorClasses } from '@mui/material';
import { CSS } from '@dnd-kit/utilities';


const INPUT_DEFAULT = {
    '& .MuiInputBase-input': {
        padding: '8.5px 14px !important',
        height: '23px !important'
    }
}

const BORDER_DEFAULT = {
    border: '1px solid var(--general-950)',
    borderRadius: '8px !important',
}

const FOCUS_STATE_BORDER = {
    border: '2px solid var(--primary-600) !important',
    borderRadius: '8px !important',
}

const HOVER_STATE_BORDER = {
    border: '2px solid var(--general-950) !important',
    borderRadius: '8px !important',
}

const DISABLED_STATE_BORDER = {
    border: '1px solid var(--shades-400) !important',
    borderRadius: '8px !important',
}

const LABEL_STYLE_DEFAULT = {
    fontSize: 'var(--ibl-ientry-p)',
    fontWeight: 'var(--ibl-font-w-600)'
}

const LABEL_STYLE_DISABLED = {
    '&.Mui-disabled': {
        color: 'var(--shades-300) !important',
    },
    color: 'var(--general-950) !important',
}

const ERROR_BORDER_DEFAULT = {
    border: '1px solid var(--error-code-600) !important',
    borderRadius: '8px !important',
}

const ERROR_HOVER_STATE_BORDER = {
    border: '2px solid var(--error-code-600) !important',
    borderRadius: '8px !important',
}

const ERROR_FOCUS_STATE_BORDER = {
    border: '2px solid var(--error-code-600) !important',
    borderRadius: '8px !important',
}

const ERROR_LABEL_STYLE_DEFAULT = {
    fontSize: 'var(--ibl-ientry-p) !important',
    fontWeight: 'var(--ibl-font-w-600) !important',
    color: 'var(--error-code-600) !important'
}

export const CustomStyleTextArea = (lCode) => {
    return {
        textAlign: lCode === 'ar' ? 'right' : 'left',
        marginBottom: '0px !important',
        '& .MuiInputBase-root': {
            marginBottom: '1px !important',
        },
        '& .MuiInputBase-root:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': HOVER_STATE_BORDER,
        '& .MuiInputBase-root.Mui-focused:not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': FOCUS_STATE_BORDER,
        '& .MuiInputBase-root.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': DISABLED_STATE_BORDER,
            '& .MuiInputAdornment-root': {
                '& svg': {
                    fill: 'var(--shades-300) !important',
                }
            }
        },
        '& .MuiInputBase-root.Mui-error:not(.Mui-focused):not(:hover) .MuiOutlinedInput-notchedOutline': ERROR_BORDER_DEFAULT,
        '& .MuiInputBase-root.Mui-error:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': ERROR_HOVER_STATE_BORDER,
        '& .MuiInputBase-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
            ...ERROR_FOCUS_STATE_BORDER
        },
        '& 	.MuiOutlinedInput-notchedOutline': {
            textAlign: lCode === 'ar' ? 'right' : 'left',
            maxHeight: 'none',
            ...BORDER_DEFAULT
        },
        '& 	.MuiInputLabel-root': {
            alignItems: 'center',
            display: 'flex',
            left: lCode === 'ar' ? 'inherit' : '0',
            right: lCode === 'ar' ? '1.75rem' : '0',
            transformOrigin: lCode === 'ar' ? 'right' : 'left',
            zIndex: 1,
            ...LABEL_STYLE_DEFAULT,
            ...LABEL_STYLE_DISABLED
        },
        '&.input-required': {
            '& 	.MuiInputLabel-root': {
                ...ERROR_LABEL_STYLE_DEFAULT
            }
        },
        '& 	.MuiFormLabel-filled': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
        },
        '& 	.MuiInputLabel-shrink': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
            paddingLeft: '2px !important',
            paddingRight: '15px !important',
            ...LABEL_STYLE_DISABLED
        },
        '& .MuiInputAdornment-root': {
            '& svg': {
                fill: 'var(--general-950)',
            }
        },
        '& .MuiInputBase-input': {
            padding: '8.5px 14px !important'
        }
    };
};

export const CustomStyleTextField = (lCode, searchIcon) => {
    let style = {};
    if(searchIcon){
        style = {
            '& .MuiAutocomplete-popupIndicator': {
                transform: 'none !important',
                fontSize:'inherit !important'
            },
            '& .MuiInputBase-input': {
                padding: '8.5px 40px 8.5px 14px !important',
                height: '23px !important'
            },
        }
    }
    return {
        textAlign: lCode === 'ar' ? 'right' : 'left',
        marginBottom: '0 !important',
        '& .MuiInputBase-root': {
            marginBottom: '1px !important',
        },
        '& .MuiAutocomplete-inputRoot': {
            padding: '0 !important'
        },
        '& .MuiInputBase-root:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': HOVER_STATE_BORDER,
        '& .MuiInputBase-root.Mui-focused:not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': FOCUS_STATE_BORDER,
        '& .MuiInputBase-root.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': DISABLED_STATE_BORDER,
            '& .MuiInputAdornment-root': {
                '& svg': {
                    fill: 'var(--shades-300) !important',
                }
            }
        },
        '& .MuiInputBase-root.Mui-error:not(.Mui-focused):not(:hover) .MuiOutlinedInput-notchedOutline': ERROR_BORDER_DEFAULT,
        '& .MuiInputBase-root.Mui-error:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': ERROR_HOVER_STATE_BORDER,
        '& .MuiInputBase-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
            ...ERROR_FOCUS_STATE_BORDER
        },
        '& 	.MuiOutlinedInput-notchedOutline': {
            textAlign: lCode === 'ar' ? 'right' : 'left',
            ...BORDER_DEFAULT
        },
        '& 	.MuiInputLabel-root': {
            alignItems: 'center',
            display: 'flex',
            left: lCode === 'ar' ? 'inherit' : '0',
            right: lCode === 'ar' ? '1.75rem' : '0',
            transformOrigin: lCode === 'ar' ? 'right' : 'left',
            zIndex: 1,
            ...LABEL_STYLE_DEFAULT,
            ...LABEL_STYLE_DISABLED
        },
        '& .input-required, &.input-required': {
            '& 	.MuiInputLabel-root': {
                ...ERROR_LABEL_STYLE_DEFAULT
            }
        },
        '& 	.MuiFormLabel-filled': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
        },
        '& 	.MuiInputLabel-shrink': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
            paddingLeft: '2px !important',
            paddingRight: '15px !important',
            ...LABEL_STYLE_DISABLED
        },
        '& .MuiInputAdornment-root': {
            '& svg': {
                fill: 'var(--general-950)',
            }
        },
        ...INPUT_DEFAULT,
        ...style
    };
};

export const CustomStyleTable = {
    '& .checkbox-table': {
        width: '50px !important',
        minWidth: '50px !important',
        padding: ' 8px 8px !important'
    },
    '& td.first-column': {
        textAlign: 'left !important',
        fontWeight: 'var(--ibl-font-w-600)',
    },
    '& .column-w400px': {
        textAlign: 'center !important',
        minWidth: '400px !important'
    }
};

export const CustomStylePagination = (hasContainer, fixed) => {
    let style = {};
    if (hasContainer) {
        style = { paddingTop: '9px !important' };
    }
    return {
        '& .MuiTablePagination-toolbar': {
            minHeight: '26px !important;',
        },
        '& .MuiSelect-select': {
            paddingTop: '0 !important;',
            paddingBottom: '0 !important;',
            paddingRight: '40px !important',
        },

        '& .MuiSelect-icon': {
            top: 'unset !important',
            alignSelf: 'center',
        },
        '& .MuiTablePagination-actions': {
            display: 'flex !important',
        },

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: fixed ? 'fixed' : 'relative',
        marginBottom: hasContainer ? '0 !important' : '16px !important',
        ...style,
        bottom: 0,
        left: 0,
        right: 0,
    };
};

export const CustomStyleDatePicker = (hasHelperText) => {
    return {
        textAlign: 'left',
        width: '100%',
        marginBottom: hasHelperText ? '0 !important' : '1.8rem !important',
        '& .MuiInputBase-root': {
            marginBottom: '1px !important',
        },
        '& .MuiInputBase-root:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': HOVER_STATE_BORDER,
        '& .MuiInputBase-root.Mui-focused:not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': FOCUS_STATE_BORDER,
        '& .MuiInputBase-root.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': DISABLED_STATE_BORDER,
            '& .MuiInputAdornment-root': {
                '& svg': {
                    fill: 'var(--shades-300) !important',
                }
            }
        },
        '& 	.MuiOutlinedInput-notchedOutline': {
            textAlign: 'left',
            ...BORDER_DEFAULT
        },
        '& 	.MuiInputLabel-root': {
            marginTop: '-4px !important',
            alignItems: 'center',
            display: 'flex',
            left: '0',
            right: '0',
            transformOrigin: 'left',
            zIndex: 1,
            ...LABEL_STYLE_DEFAULT,
            ...LABEL_STYLE_DISABLED
        },
        '& 	.MuiFormLabel-filled': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
            paddingLeft: '1px',
        },
        '& 	.MuiInputLabel-shrink': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
            paddingLeft: '2px !important',
            paddingRight: '15px !important',
        },
        '& 	.MuiOutlinedInput-input': {
            padding: '8.5px 14px',
        },
        '& .MuiInputAdornment-root': {
            '& svg': {
                fill: 'var(--general-950)',
            }
        },
        ...INPUT_DEFAULT
    };
};

export const CustomStyleDatePickerRequired = (hasHelperText) => {
    return {
        textAlign: 'left',
        width: '100%',
        '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': ERROR_HOVER_STATE_BORDER,
        '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': ERROR_FOCUS_STATE_BORDER,
        '& 	.MuiOutlinedInput-notchedOutline': {
            textAlign: 'left',
            ...ERROR_BORDER_DEFAULT
        },
        '& 	.MuiButtonBase-root': {
            top: '3px',
        },
        '& 	.MuiInputLabel-root': {
            marginTop: '-4px !important',
            alignItems: 'center',
            display: 'flex',
            left: '0',
            right: '0',
            transformOrigin: 'left',
            zIndex: 1,
            ...ERROR_LABEL_STYLE_DEFAULT
        },
        '& 	.MuiFormLabel-filled': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
            paddingLeft: '1px',
        },
        '& 	.MuiInputLabel-shrink': {
            marginTop: '-5px',
            background: 'var(--general-00)',
            width: '100%',
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            zIndex: '1 !important',
            paddingLeft: '2px !important',
            paddingRight: '15px !important',
        },
        '& 	.MuiOutlinedInput-input': {
            padding: '8.5px 14px',
        },
        '& .MuiInputAdornment-root': {
            '& svg': {
                fill: 'var(--general-950)',
            }
        },
        ...INPUT_DEFAULT
    }
};

export const CustomStyleDatePickerPopper = ({ containerHeight, bodyHeight }) => {

    return {
        '& .MuiPaper-root': {
            borderRadius: '8px',
            background: 'var(--general-00)',
            boxShadow: '0px 2px 4.8px 0px rgba(0, 0, 0, 0.50)',
            "& .MuiPickersLayout-contentWrapper": {
             height: `${containerHeight}px !important`,//calculate
             "& > div": {
                 height: `${containerHeight}px !important`,//calculate
             }
            }
        },
        '& .MuiDayCalendar-slideTransition':{
            height:bodyHeight ? `${bodyHeight}px`: undefined,
            minHeight:bodyHeight ? `${bodyHeight}px` : undefined,
        },
        '& .MuiDateCalendar-root': {
            overflowY:  bodyHeight ? undefined : 'auto !important',
            '& .MuiPickersCalendarHeader-root': {
                '& .MuiPickersCalendarHeader-labelContainer': {
                    '& .MuiPickersFadeTransitionGroup-root': {
                        '& .MuiPickersCalendarHeader-label': {
                            color: 'var(--general-950)',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: 'var(--ibl-font-w-600)',
                            lineHeight: '120%',
                            fontFeatureSettings: "'liga' off, 'clig' off",
                            textTransform: 'Capitalize'
                        },

                        '& button': {
                            backgroundColor: 'var(--transparent)',

                            '&:hover': {
                                backgroundColor: 'var(--transparent) !important',
                            },

                            '& svg path': {
                                fill: 'var(--general-950)',
                            },

                            '&:hover svg path': {
                                fill: 'var(--shades-600)',
                            },
                        },
                    },
                },
            }
        },
        '& .MuiDayCalendar-weekContainer': {
            '& .MuiPickersDay-root.Mui-selected': {
                display: 'flex',
                width: '30px',
                height: '30px',
                padding: '10px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                flexShrink: 0,
                color: 'var(--text-50)',
                textAlign: 'center',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-500)',
                lineHeight: '120%',
                backgroundColor: 'var(--primary-800)',
                margin: '0 !important'
            },
            '& .MuiPickersDay-root.Mui-disabled:not(.Mui-selected)': {
                color: 'var(--shades-400)',
                textAlign: 'center',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-500)',
                lineHeight: '120%',
                fontFeatureSettings: "'liga' off, 'clig' off",
                margin: '0 !important'
            },
            '& .MuiPickersDay-root:not(.Mui-selected)': {
                display: 'flex',
                width: '30px',
                height: '30px',
                padding: '10px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                flexShrink: 0,
                color: 'var(--general-950)',
                textAlign: 'center',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-500)',
                lineHeight: '120%',
                margin: '0 !important'
            },
        },
        '& .MuiDayCalendar-root': {
            '& .MuiDayCalendar-header': {
                '& .MuiDayCalendar-weekDayLabel': {
                    display: 'flex',
                    width: '30px',
                    height: '30px',
                    padding: '10px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'var(--primary-800)',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 'var(--ibl-font-w-700)',
                    lineHeight: '120%',
                    fontFeatureSettings: "'liga' off, 'clig' off",
                },
            },
        },
        '& .MuiMonthCalendar-root': {
            height:bodyHeight ? `${bodyHeight}px`: undefined,
            minHeight:bodyHeight ? `${bodyHeight}px` : undefined,
            overflowY: 'auto !important',
            '& .MuiPickersMonth-root': {
                '& .MuiPickersMonth-monthButton': {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
            }
        },
        '& .MuiYearCalendar-root': {
            height:bodyHeight ? `${bodyHeight}px`: undefined,
            minHeight:bodyHeight ? `${bodyHeight}px` : undefined,
            overflowY: bodyHeight ? 'auto !important' : 'hidden !important',
            '& .MuiPickersYear-root': {
                '& .MuiPickersYear-yearButton': {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
            }
        },
        '& .MuiList-root': {
            color: 'var(--general-950)',
            textAlign: 'center',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 'var(--ibl-font-w-500)',
            lineHeight: '120%', // 16.8px
            minWidth: '60px',
            '& .MuiButtonBase-root.Mui-selected': {
                borderRadius: '50%',
                background: 'var(--primary-800)',
                color: 'var(--text-50)',
            },
        },
    }
};
export const CustomStyleTimePickerPopper = (isPmSelected) => {
    return {
        '& .MuiClockNumber-root:not(.Mui-disabled)': {
            color: 'var(--general-950)',
            '&.Mui-selected':{
                color: 'var(--general-00) !important',
            }
        },
        '& .MuiClock-pin': {
            backgroundColor: 'var(--primary-500)',
        },
        '& .MuiClockPointer-root': {
            backgroundColor: 'var(--primary-500)',
        },
        '& .MuiClockPointer-thumb': {
            borderColor: 'var(--primary-500) !important',
            backgroundColor: 'var(--general-950)',
        },
        '& .MuiButtonBase-root:not(.Mui-disabled)':{
            color: 'var(--primary-500)',
            ':hover':{
                backgroundColor: 'var(--primary-50)',
            }
        },
        '& .MuiClock-amButton:not(.Mui-disabled)': {
            backgroundColor: !isPmSelected ? 'var(--primary-800) !important' : 'transparent',
            color: !isPmSelected ? 'var(--text-50) !important' : 'var(--general-950) !important',
        },

        '& .MuiClock-pmButton:not(.Mui-disabled)': {
            backgroundColor: isPmSelected ? 'var(--primary-800) !important' : 'transparent',
            color: isPmSelected ? 'var(--text-50) !important' : 'var(--general-950) !important',
        },

        '& .MuiClock-amButton:hover': {
            backgroundColor: !isPmSelected ? 'var(--primary-800) !important' : 'var(--primary-50) !important',
        },

        '& .MuiClock-pmButton:hover': {
            backgroundColor: isPmSelected ? 'var(--primary-800) !important' : 'var(--primary-50) !important',
        },
    }
};
export const CustomStyleDateTimePickerPopper = ({ containerHeight, bodyHeight, isPmSelected }) => {
    return {
        '& .MuiPaper-root': {
            borderRadius: '8px',
            background: 'var(--general-00)',
            boxShadow: '0px 2px 4.8px 0px rgba(0, 0, 0, 0.50)',
            "& .MuiPickersLayout-contentWrapper": {
                height: `${containerHeight}px !important`,//calculate
                "& > div": {
                    height: `${containerHeight}px !important`,//calculate
                }
            }
        },
        '& .MuiDayCalendar-slideTransition':{
            height:`${bodyHeight}px`,
            minHeight:`${bodyHeight}px`,
        },
        '& .MuiDateCalendar-root': {
            height: `${containerHeight}px !important`,//calculate
            '& .MuiPickersCalendarHeader-root': {
                '& .MuiPickersCalendarHeader-labelContainer': {
                    '& .MuiPickersFadeTransitionGroup-root': {
                        '& .MuiPickersCalendarHeader-label': {
                            color: 'var(--general-950)',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: 'var(--ibl-font-w-600)',
                            lineHeight: '120%',
                            fontFeatureSettings: "'liga' off, 'clig' off",
                            textTransform: 'Capitalize'
                        },

                        '& button': {
                            backgroundColor: 'var(--transparent)',

                            '&:hover': {
                                backgroundColor: 'var(--transparent) !important',
                            },

                            '& svg path': {
                                fill: 'var(--general-950)',
                            },

                            '&:hover svg path': {
                                fill: 'var(--shades-600)',
                            },
                        },
                    },
                },
            },
            '& .MuiYearCalendar-root':{
                height: '210px !important'
            }
        },
        '& .MuiMultiSectionDigitalClock-root': {
            padding: '16px',
            height:`${bodyHeight}`,
            '& .MuiMultiSectionDigitalClockSection-root':{
                paddingLeft:'12px !important',
                paddingRight:'15px !important',
                overflowX:'hidden !important',
                '& .MuiMultiSectionDigitalClockSection-item': {
                    padding:'0 !important',
                    margin:'0 !important',
                    minHeight:'30px !important',
                    width:'30px !important',
                }
            },

        },
        '& .MuiDayCalendar-weekContainer': {
            '& .MuiPickersDay-root.Mui-selected': {
                display: 'flex',
                width: '30px',
                height: '30px',
                padding: '10px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                flexShrink: 0,
                color: 'var(--text-50)',
                textAlign: 'center',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-500)',
                lineHeight: '120%',
                backgroundColor: 'var(--primary-800)'
            },
            '& .MuiPickersDay-root.Mui-disabled:not(.Mui-selected)': {
                color: 'var(--shades-400)',
                textAlign: 'center',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-500)',
                lineHeight: '120%',
                fontFeatureSettings: "'liga' off, 'clig' off",
            },
            '& .MuiPickersDay-root:not(.Mui-selected)': {
                display: 'flex',
                width: '30px',
                height: '30px',
                padding: '10px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                flexShrink: 0,
                color: 'var(--general-950)',
                textAlign: 'center',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-500)',
                lineHeight: '120%',
                '&:focus':{
                    backgroundColor:'var(--primary-50)'
                }
            },
        },
        '& .MuiDayCalendar-root': {
            '& .MuiDayCalendar-header': {
                '& .MuiDayCalendar-weekDayLabel': {
                    display: 'flex',
                    width: '30px',
                    height: '30px',
                    padding: '10px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'var(--primary-800)',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 'var(--ibl-font-w-700)',
                    lineHeight: '120%',
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    margin: '0 !important'
                },
            },
        },
        '& .MuiMonthCalendar-root': {
            '& .MuiPickersMonth-root': {
                '& .MuiPickersMonth-monthButton': {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
            }
        },
        '& .MuiYearCalendar-root': {
            '& .MuiPickersYear-root': {
                '& .MuiPickersYear-yearButton': {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
            }
        },
        '& .MuiList-root': {
            color: 'var(--general-950)',
            textAlign: 'center',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 'var(--ibl-font-w-500)',
            lineHeight: '120%', // 16.8px
            minWidth: '60px',
            '& .MuiButtonBase-root.Mui-selected': {
                borderRadius: '50%',
                background: 'var(--primary-800)',
                color: 'var(--text-50)',
            },
        },
        '& .MuiTabs-root':{
            '& .Mui-selected': {
                '& svg':{
                    fill: 'var(--primary-500)'
                }
            }
        },
        '& .MuiTabs-indicator':{
            backgroundColor: 'var(--primary-500)'
        },
        '& .MuiDateTimePickerToolbar-dateContainer':{
            '& .MuiTypography-root':{
                fontSize: 'var(--fs-24px)'
            }
        },
        '& .MuiDateTimePickerToolbar-timeContainer':{
            '& .MuiTypography-root':{
                fontSize: 'var(--fs-24px)'
            }
        },
        ...CustomStyleTimePickerPopper(isPmSelected)
    }
};

export const CustomStyleFormHelperText = (showCounter, marginBottom = true) => {
    return {
        color: 'var(--general-950)',
        marginBottom: marginBottom ? showCounter ? '1rem !important' : `0.8rem !important` : '0 !important',
        fontSize: '10px !important',
        letterSpacing: 'normal !important',
        textAlign: 'left !important',
        fontWeight: 'var(--ibl-font-w-600) !important',
        fontFamily: 'var(--primary-font) !important',
        '&.Mui-error': {
            color: 'var(--error-code-600) !important',
            '& .counter-numbers': {
                color: 'var(--error-code-600) !important',
            }
        },
        '&:not(.Mui-error)': {
            '& .counter-numbers': {
                color: 'var(--general-950)',
            }

        },
        '&[disabled]:not(.Mui-error)': {
            color: 'var(--shades-300) !important',
        },
        transition: 'none !important',
    };
};
export const CustomStylePhoneInput = {
    '& .special-label': {
        fontSize: '11px',
        left: '9px',
        top: '-10px',
        fontWeight: 'var(--ibl-font-w-600)',
        fontFamily: 'var(--primary-font) !important',
    },
    '& .required-phone': {
        '& .special-label': {
            '&::after': {
                content: '" *"'
            }
        }
    },
    '& .special-label:not(.focused):not(.error)': {
        color: 'var(--general-950) !important',
    },
    '& .special-label.focused:not(.error)': {
        color: 'var(--general-950) !important',
    },
    textAlign: 'left',
    '& .react-tel-input': {
        marginBottom: '1px !important',
    },
    '& .form-control': {
        width: '100% !important',
        height: '40px !important',
        boxShadow: 'none',
        borderRadius: '4px !important',
        ...BORDER_DEFAULT
    },
    '& .form-control:not(:focus):hover': HOVER_STATE_BORDER,
    '& .form-control:focus': {
        ...FOCUS_STATE_BORDER,
        boxShadow: 'none !important'
    },
    '&.error': {
        '& .form-control:not(:focus):not(:hover)': {
            ...ERROR_BORDER_DEFAULT
        },
        '& .form-control:not(:focus):hover': {
            ...ERROR_HOVER_STATE_BORDER
        },
        '& .form-control:focus': {
            ...ERROR_FOCUS_STATE_BORDER,
            boxShadow: 'none !important'
        },
        '& .special-label.error': {
            color: 'var(--error-code-600) !important',
        },
        marginBottom: '0 !important',
    },
    '&:not(.error)': {
        marginBottom: '1.8rem !important',
    },
    ...INPUT_DEFAULT
};
export const CustomStyleSelectRequired = {
    width: '100%',
    textAlign: 'left',
    '& .MuiInputBase-root': {
        marginBottom: '1px !important',
        width: '100%',
    },
    '& .MuiInputBase-root.Mui-error:hover .MuiOutlinedInput-notchedOutline': ERROR_HOVER_STATE_BORDER,
    '& .MuiInputBase-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        ...ERROR_FOCUS_STATE_BORDER
    },
    '& 	.MuiOutlinedInput-notchedOutline': {
        textAlign: 'left',
        ...ERROR_BORDER_DEFAULT
    },
    '& 	.MuiInputLabel-root': {
        marginTop: '-4px !important',
        alignItems: 'center',
        display: 'flex',
        left: '0 !important',
        right: '0 !important',
        transformOrigin: 'left',
        zIndex: 1,
        ...ERROR_LABEL_STYLE_DEFAULT
    },
    '& 	.MuiFormLabel-filled': {
        marginTop: '-5px',
        background: 'var(--general-00)',
        width: '100%',
        minWidth: 'fit-content',
        maxWidth: 'fit-content',
        zIndex: '1 !important',
        paddingLeft: '1px',
    },
    '& 	.MuiInputLabel-shrink': {
        marginTop: '-5px',
        background: 'var(--general-00)',
        width: '100%',
        minWidth: 'fit-content',
        maxWidth: 'fit-content',
        zIndex: '1 !important',
        paddingLeft: '6px !important',
        paddingRight: '15px !important',
        left: '-4px !important',
    },
    ...INPUT_DEFAULT
};

export const CustomStyleSelect = {
    width: '100%',
    textAlign: 'left',
    marginBottom: '1.8rem !important',
    '& .MuiInputBase-root': {
        marginBottom: '1px !important',
        width: '100%',
    },
    '& .MuiInputBase-root:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': HOVER_STATE_BORDER,
    '& .MuiInputBase-root.Mui-focused:not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': FOCUS_STATE_BORDER,
    '& .MuiInputBase-root.Mui-disabled': {
        '& .MuiOutlinedInput-notchedOutline': DISABLED_STATE_BORDER,
        '& .MuiInputAdornment-root': {
            '& svg': {
                fill: 'var(--shades-300) !important',
            }
        }
    },
    '& 	.MuiOutlinedInput-notchedOutline': {
        textAlign: 'left',
        ...BORDER_DEFAULT
    },
    '& 	.MuiInputLabel-root': {
        marginTop: '-4px !important',
        alignItems: 'center',
        display: 'flex',
        left: '0 !important',
        right: '0 !important',
        transformOrigin: 'left',
        zIndex: 1,
        ...LABEL_STYLE_DEFAULT,
        ...LABEL_STYLE_DISABLED
    },
    '& 	.MuiFormLabel-filled': {
        marginTop: '-5px',
        background: 'var(--general-00)',
        width: '100%',
        minWidth: 'fit-content',
        maxWidth: 'fit-content',
        zIndex: '1 !important',
        paddingLeft: '1px',
    },
    '& 	.MuiInputLabel-shrink': {
        marginTop: '-5px',
        background: 'var(--general-00)',
        width: '100%',
        minWidth: 'fit-content',
        maxWidth: 'fit-content',
        zIndex: '1 !important',
        paddingLeft: '6px !important',
        paddingRight: '15px !important',
        left: '-4px !important',
        ...LABEL_STYLE_DISABLED
    },
    ...INPUT_DEFAULT
};

export const CustomStyleCheckbox = (fontSize, trans, bold, marginbutton) => {
    return {
        '& .MuiButtonBase-root': {
            padding: '4px !important'
        },
        '& 	.MuiFormControlLabel-label': {
            fontSize: fontSize ? fontSize + 'px !important' : '14px',
            fontFamily: 'var(--primary-font) !important',
            fontWeight: bold + ' !important',
        },
        '& .Mui-disabled': {
            '& .MuiTypography-root': LABEL_STYLE_DISABLED,
            '& .MuiSvgIcon-root': {
                fill: 'var(--shades-300) !important',
            }
        },

        marginLeft: '0 !important',
        marginRight: '0 !important',
        marginTop: '0 !important',
        marginBottom: marginbutton ? '0rem !important' : trans ? '1.8rem !important' : '0rem !important',
    };
};

export const CustomStyleRadio = (hasHelperText) => {
    return {
        "&.MuiFormControlLabel-root": {
            color: "var(--general-950)",
            fontFamily: "var(--primary-font) !important",
            fontWeight: "var(--ibl-font-w-400) !important",
            marginBottom: hasHelperText ? "0 !important" : "1.4rem !important",
        },
        "& .MuiTouchRipple-root": {
            color: 'var(--primary-800) !important'
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: 'var(--primary-800) !important'
        },
    }
}

export const CustomRadioButton = styled(Radio)(({ $color }) => ({
    "& .MuiSvgIcon-root": {
        fill: $color || "var(--primary-800)",
    },
}));

export const CustomStyleDivColorPicker = {
    display: 'flex',
    width: '40px',
    height: '100%',
    minHeight: '40px',
    padding: '4px',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: '0',
    borderRadius: '8px',
    border: '1px solid  var(--general-950)'
};

export const CustomStyleColorPickerPreview = ({fillColor, strokeColor}) => {
    return {
        container:{
            border:" 1px solid " + strokeColor
        },
        body: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            flex: '1 0 0',
            alignSelf: 'stretch',
            borderRadius: '6px',
            background: fillColor,
        }

    };
};

export const CustomStyleColorPicker = (color) => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        flex: '1 0 0',
        alignSelf: 'stretch',
        borderRadius: '6px',
        background: color,
    };
};

export const CustomStyleLabel = (bold) => {
    return {
        color: 'var(--general-950)',
        fontWeight: bold + ' !important',
        fontFamily: 'var(--primary-font) !important',
        fontSize: '12px',
        whiteSpace: 'break-spaces !important',
        textTransform: 'uppercase',
    };
};
export const CustomStyleTemplate = (margin, width) => {
    return {
        width: width,
        height: '35px',
        backgroundColor: 'var(--general-00)',
        border: '2px solid var(--dark-2)',
        borderRadius: '5px',
        margin: margin ? '1px' : '2px',
    };
};

export const CustomTruncateLabel = (bold) => {
    return {
        color: 'var(--gray)',
        fontWeight: `${bold} !important`,
        fontFamily: 'var(--primary-font) !important',
        fontSize: '12px',
        textTransform: 'uppercase',

        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',

        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
    };
};

export const CustomStyleChip = {
    fontWeight: 'var(--ibl-font-w-600)',
    fontFamily: 'var(--primary-font) !important',
    fontSize: '12px',
    whiteSpace: 'break-spaces !important',
    '& .MuiChip-label': {
        textTransform: 'none',
        maxWidth: '210px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
};
export const LargeChipStyle = {
    fontSize: '12px',
    borderRadius: '4px',
    paddingX: '12px',
};

export const CompactChipStyle = {
    height: '22px',
    fontSize: '12px',
    borderRadius: '20px',
    paddingX: '6px',
};

export const DotChipStyle = {
    width: '19px',
    height: '19px',
     '& .MuiChip-label': {
      paddingLeft: 0,
      paddingRight: 0,
    }
};

export const CustomStyleSwitch = (showBorder) => ({
     '&.MuiFormControlLabel-root': {
    border: showBorder ? '1px solid var(--general-950)' : 'none',
    borderRadius: '8px',
    height: '40px',
    paddingLeft: '16px',
    paddingRight: '16px',
    margin: '0px',
  },
    '& .MuiFormControlLabel-label': {
        color: showBorder ? 'var(--general-950) !important':'',
        fontFamily: 'var(--primary-font) !important',
        lineHeight: '120%',
        float: 'left',
        width: '100%',
        paddingRight: '16px'
    },
    '& .MuiSwitch-root': {
        width: 42,
        height: 24,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            color: 'var(--general-00)',
            transform: 'translate(1px, 1px)',
            '&.Mui-checked': {
                color: 'var(--general-00)',
                transform: 'translate(20px, 1px)',
                '& + .MuiSwitch-track': {
                    backgroundColor: 'var(--primary-600)',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: 'var(--primary-600)',
                border: '6px solid var(--general-00)',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: 'var(--shades-300)'
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 21,
            height: 21,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: 'var(--shades-300)',
            opacity: 1
        },
    },
    border:showBorder ?  '1px solid var(--general-950)':' ',
    '&:hover':showBorder ? HOVER_STATE_BORDER:'',
    '&:focus': FOCUS_STATE_BORDER,
    borderRadius: '8px',
    height: '40px',
    paddingLeft: '16px',
    paddingRight: '16px',
    margin: '0px'
});

export const CustomStyleSwitchContainer = {
    '& .switch-title': {
        position: 'absolute',
        transform: 'translateY(-9px) scale(0.8)',
    },
    '& .switch-container': {
        alignItems: 'center',
        transform: 'translateY(5px)',
    },
    marginBottom: '1.8rem !important',
};

export const CustomStyleCardContainer = () => {
    return {
        marginBottom: '1.8rem !important',
        '& .custom-title-card': {
            display: 'grid',
            font: 'var(--primary-font)',
            letterSpacing: '0px',
            color: 'var(--grey)',
            fontWeight: 'bold',
        },
        '& .custom-card-container': {
            boxShadow: 'none !important',
            '& .MuiCardContent-root': {
                background: 'var(--accent-grey) 0% 0% no-repeat padding-box',
                borderRadius: '4px',
                position: 'relative',
                overflow: 'auto',
            },
            '&.MuiCardActions-root': {
                background: 'var(--general-00)',
                position: 'absolute',
                padding: '0px',
                bottom: 0,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
            },
        },
    };
};

export const CustomStyleCardContainerRequired = () => {
    return {
        marginBottom: '0rem !important',
        '& .custom-title-card': {
            display: 'grid',
            font: 'var(--primary-font)',
            letterSpacing: '0px',
            color: 'var(--error-code-600)',
            fontWeight: 'bold',
        },
        '& .custom-card-container': {
            boxShadow: 'none !important',
            border: '1px solid var(--error-code-600) !important',
            '& .MuiCardContent-root': {
                background: 'var(--accent-grey) 0% 0% no-repeat padding-box',
                borderRadius: '4px',
                position: 'relative',
                overflow: 'auto',
            },
            '&.MuiCardActions-root': {
                background: 'var(--general-00)',
                position: 'absolute',
                padding: '0px',
                bottom: 0,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
            },
        },
    };
};

export const CustomStyleListItem = (display, color = 'var(--shades-400)') => {
    return {
        margin: 0,
        padding: '8px',
        background: 'var(--general-00)',
        borderRadius: '4px',
        display: display,
        '& .MuiListItemIcon-root': {
            '& .MuiFormControlLabel-root': {
                margin: '0 !important',
            },
        },
        '& .MuiCheckbox-root': {
            padding: '0 5px 0 0 !important',
        },
        '& .MuiListItemText-primary': {
            userSelect: 'none',
            textAlign: 'left',
            font: 'var(--primary-font)',
            fontSize: '10px !important',
            color: color,
            fontWeight: 'bold',
            letterSpacing: '0px',
            opacity: 1,
            margin: '0 !important',
        },
        '& .custom-list-actions': {
            marginLeft: 'auto !important',
        },
    };
};

export const CustomStyleOverlayExpandImage = {
    width: '100%',
    height: '100%',
    zIndex: 9999,
    opacity: 0.6,
};
export const CustomStyleExpandImage = {
    objectFit: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    boxShadow: '$box-shadow',
    transition: 'background 0.2s ease-in-out, opacity 0.2s ease-in-out',
    transform: 'none',
    zIndex: 10000,
    background: 'var(--general-00)',
    position: 'fixed',
    height: 'calc(90vh - 100px)',
    width: '60%',
    margin: 'auto',
    left: 0,
    right: 0,
    top: '80px',
    borderRadius: '4px',
};

export const CustomStyleImage = (text) => {
    return {
        width: '20px',
        height: '20px',
        marginRight: text ? '8px' : '0px',
        verticalAlign: 'middle',
    };
};

export const CustomStyleDropdownAnchorOrigin = {
    vertical: 'top',
    horizontal: 'left',
};

export const CustomStyleDropdownTransformOrigin = {
    vertical: 'top',
    horizontal: 'right',
};

export const CustomStyleListContainer = (styleType) => {
    if (styleType) {
        return { listStyleType: styleType + ' !important' };
    }
    return {};
};

export const CustomStyleOtpContainer = {
    '& .otp-title': {
        padding: '0',
    },
    '& .otp-inputs': {
        '& > div:first-child': {
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '1.8rem !important',
            '& > div': {
                marginLeft: '5px' /* Aplica margen izquierdo */,
                marginRight: '5px' /* Aplica margen derecho */,
            },
            '& > div:first-child': {
                marginLeft: 0 /* El primer div no tendrá margen a la izquierda */,
            },
            /* Evitar margen en el último div a la izquierda */
            '& > div:last-child': {
                marginRight: 0 /* El último div no tendrá margen a la derecha */,
            },

            /* Aseguramos que los divs no tengan márgenes fuera de lo que es necesario */
            '& > div:last-child + div ': {
                marginRight: 0 /* El último div solo tendrá margen izquierdo */,
            },
        },
    },
    '& input': {
        width: '40px !important',
        height: '40px !important',
        fontWeight: 'normal',
        borderRadius: '4px',
        background: 'transparent',
        border: '1px solid var(--grey-with-opacity23)',
        outline: 'none',
        textAlign: 'center',
    },
    '& input:focus': {
        border: '2px solid var(--primary-color) !important',
    },
};

export const CustomStyleOtpContainerRequired = {
    '& .otp-title': {
        padding: '0',
        '& .MuiFormLabel-root': {
            color: 'var(--error-code-600) !important',
        },
    },
    '& .otp-inputs': {
        '& > div:first-child': {
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '0 !important',
            '& > div': {
                marginLeft: '5px' /* Aplica margen izquierdo */,
                marginRight: '5px' /* Aplica margen derecho */,
            },
            '& > div:first-child': {
                marginLeft: 0 /* El primer div no tendrá margen a la izquierda */,
            },
            /* Evitar margen en el último div a la izquierda */
            '& > div:last-child': {
                marginRight: 0 /* El último div no tendrá margen a la derecha */,
            },

            /* Aseguramos que los divs no tengan márgenes fuera de lo que es necesario */
            '& > div:last-child + div ': {
                marginRight: 0 /* El último div solo tendrá margen izquierdo */,
            },
        },
    },
    input: {
        width: '40px !important',
        height: '40px !important',
        fontWeight: 'normal',
        borderRadius: '4px',
        background: 'transparent',
        border: '1px solid var(--error-code-600) !important',
        outline: 'none',
        textAlign: 'center',
    },
};

export const CustomStyleWarningLegend = {
    backgroundColor: 'blanchedalmond',
    padding: '25px',
    borderRadius: '4px',
    color: 'black !important',
};

export const CustomStyleDropdownPagination = {
    '.css-18ms9sm-MuiTablePagination-root': {
        padding: '0px',
    },
    '.css-16c50h-MuiInputBase-root-MuiTablePagination-select': {
        marginLeft: '0px',
        marginRight: '0px',
    },
    '.MuiTablePagination-displayedRows': {
        display: 'none',
    },
    '.MuiTablePagination-actions': {
        display: 'none',
    },
    '.css-11bfvty-MuiToolbar-root-MuiTablePagination-toolbar': {
        padding: '0px',
    },
};

export const CustomButtonStyle = {
    button: {
        borderRadius: '8px',
        textTransform: 'capitalize',
        fontWeight: 'var(--ibl-font-w-600)',
        fontSize: '0.875rem',
        boxShadow: 'none',
    },
};

export const CustomUserChipStyle = {
    chip: () => ({
        backgroundColor: 'var(--shades-100)',
        color: 'var(--general-950)',
        border: '1px solid var(--shades-300)',
        borderRadius: '8px',
        marginRight: '1rem',
        height: 'auto',
        minHeight: 32,
        pr: '4px',
        marginTop: '1rem',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        '&:hover': {
            backgroundColor: 'var(--shades-200)',
            color: 'var(--general-950)',
            border: '1px solid var(--shades-400)',
        },
        '.MuiChip-deleteIcon': {
            color: 'var(--secondary-50)',
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            marginRight: 0,
            paddingRight: 0,
            cursor: 'pointer',
            '&:hover': {
                color: 'var(--shades-400)',
            },
        },
        letterSpacing: "0.16px",
        lineHeight: "150%"
    }),
    compact: {
        borderRadius: '20px !important',
    },
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    nameText: () => ({
        fontSize: 'var(--fs-chip)',
        color: 'var(--general-950)',
        fontWeight: 'var(--ibl-font-w-400)',
        fontStyle: 'normal',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
    }),
    avatar: {
        backgroundColor: 'transparent',
        width: 24,
        height: 24,
    },
    icon: {
        '& svg path': {
            fill: 'var(--shades-400)',
        },
    },
};

export const CustomExpandableTableStyles = {
    root: {
        '& table ': {
            borderCollapse: 'separate !important',
            borderSpacing: '0 16px',
        },
        '& table tr th': {
            fontFamily: 'var(--primary-font)',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 'var(--ibl-font-w-600)',
            lineHeight: '120%', // 16.8px
            letterSpacing: '0.48px',
            textTransform: 'uppercase',
            color: 'var(--general-950)',
            padding: '0 8px',
            borderBottom: 'none !important'
        },
        '& table tr td': {
            fontFamily: 'var(--primary-font)',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 'var(--ibl-font-w-400)',
            lineHeight: '150%', // 16.8px
            textTransform: 'capitalize',
            letterSpacing: '0.86px',
            color: 'var(--general-950)',
            padding: '0 8px',
        },
    },
    tableContainer: {
        border: 'none',
    },
    table: {
        border: 'none',
    },
    row: {
        backgroundColor: 'var(--shades-50)',
        border: '1px solid var(--shades-100)',
        borderRadius: '8px',
        '&:not(.rowActive):hover': {
            backgroundColor: 'var(--shades-100)',
            '& td': {
                fontFamily: 'var(--primary-font)',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-600) !important',
                lineHeight: '150%',
                textTransform: 'capitalize',
                color: 'var(--general-950)',
                padding: '0 8px',
            },
        },
        '&.rowActive': {
            backgroundColor: 'var(--shades-200)',
            '&:hover': {
                backgroundColor: 'var(--shades-200)',
            },
            '& td': {
                fontFamily: 'var(--primary-font)',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--ibl-font-w-600) !important',
                lineHeight: '150%',
                textTransform: 'capitalize',
                color: 'var(--general-950)',
                padding: '0 8px',
            },
        },
    },
    expandedRow: {
        padding: '16px 16px 48px 48px',
        borderRadius: '0px 0px 4px 4px',
        background: 'var(--shades-50)',
    },
    expandedBox: {
        margin: 2,
    },
    cellText: {
        textTransform: 'capitalize',
        paddingX: '20px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px',
    },
    cellOptions: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',

    },
};

export const CustomDropdownMenuStyles = {
    iconButton: {
        color: 'var(--shades-400)',
        cursor: 'pointer',
        '&:hover': {
            color: 'var(--shades-950)',
            cursor: 'pointer',
        },
        '&.rowActive': {
            color: 'var(--shades-950)',
        },
    },
    menuPaper: {
        borderRadius: '12px',
        border: `1px solid  #000000`,
        boxShadow: '0px 2px 4.8px 0px #000000',
        mt: 1,
        minWidth: 160,
        overflow: 'visible',
        '& .MuiMenuItem-root': {
            justifyContent: 'space-between',
            px: 2,
            py: 1.5,
        },
    },
    menuItemBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    menuItemText: {
        color: 'black',
    },
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
};

export const CustomStyleDisplayView = (marginLeft) => {
    return {
        marginLeft: marginLeft + 'px',
    };
};

export const CustomStyleListItemButton = {
    backgroundColor: 'var(--general-00)',
    '&:hover': {
        backgroundColor: 'var(--shades-100)',
    },
}

export const WebcamContainer = (border) => {
    return {
        width: '100%',
        height: '276px',
        position: "relative",
        border: border ? "2px solid var(--secondary-500) " : "node",
        borderRadius: "5px",
    }
}

export const WebcamCountContainer = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 50,
    height: 50,
    borderRadius: "50%",
    backgroundColor: 'var(--secondary-500)',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.8rem",
    fontWeight: "bold",
    color: 'var(--general-00)',
    pointerEvents: "none",
    zIndex: 10,
};


export const WebcamStyles = {
    width: "100%",
    height: "100%",
    objectFit: "fill",
    borderRadius: "5px",
};

export const IconTextLineStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    justifyContent: 'flex-start',
};

export const CustomMdChip = (disabled) => {
    let borderColor = "var(--shades-300)";
    let backgroundColor = "var(--shades-100)";

    if (disabled) {
        borderColor = "var(--shades-300)";
        backgroundColor = "var(--shades-100)";
    }

    return {
        display: 'flex',
        width: '400px',
        padding: '12px',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        borderRadius: '8px',
        border: `ipx solid ${borderColor}`,
        background: backgroundColor,
        height: 'auto',
        boxSizing: 'border-box',
        '& button:hover svg path': {
            fill: 'var(--shades-600)',
        },
        '& button': {
            backgroundColor: 'var(--transparent)',
            '&:hover': {
                backgroundColor: 'var(--transparent) !important',
            },
        },
        '&:hover': {
            backgroundColor: 'var(--shades-100)',
        },
        icon: {
            fill: disabled ? 'var(--shades-200)' : 'var(--shades-400)',
            color: disabled ? 'var(--shades-100)' : 'var(--shades-400)',
        },
    };
};


export const CustomMdChipComplete = (disabled) => {
    let borderColor = "var(--shades-300)";
    let backgroundColor = "var(--shades-50)";
    let fontColor = "var(--general-950)";

    if (disabled) {
        borderColor = "var(--shades-300)";
        backgroundColor = "var(--shades-100)";
        fontColor = "var(--shades-400)";
    }

    return {
        display: 'flex',
        marginTop: '0 !important',
        width: '100%',
        padding: '8px',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        borderRadius: '8px',
        border: `1px solid ${borderColor}`,
        background: backgroundColor,
        height: 'auto',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: 'var(--shades-100)',
        },
        '& button:hover svg path': {
            fill: 'var(--shades-600)',
        },
        '& button': {
            backgroundColor: 'var(--transparent)',
            '&:hover': {
                backgroundColor: 'var(--transparent) !important',
            },
        },
        p: {
            color: fontColor,
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '150%',
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            '&.p_cmc_title':{
                fontWeight: 'var(--ibl-font-w-600)',
            }
        },
        icon: {
            fill: disabled ? 'var(--shades-200)' : 'var(--shades-400)',
            color: disabled ? 'var(--shades-100)' : 'var(--shades-400)',
        },
    };
};


export const CustomAutoCompleteMenuOptionStyle = {
    display: 'flex',
    marginTop : '0 !important',
    padding: ' 4px 6px',
    justifyContent: 'space-between !important',
    alignItems: 'center',
    borderRadius: '4px',
    background: 'var(--general-00)',
    height: 'auto',
    boxSizing: 'border-box',
    width: "100%",
    avatar: {
        backgroundColor: 'var(--general-950)',
        fill: 'var(--general-950)',
        width: '24px',
        height: '24px',
    },
    icon: {
        fontSize: '16px',
        '&:hover': {
            color: 'var(--general-950)',
        },
    }
};

export const CustomPopperAutocompleteStyle ={
    width: '100%',
    zIndex: 1300,
    padding: '0',
    gap:'8px',
    customWidth: '400px'
}

export const ComponentPaperAutocomplete = {
    boxShadow: '0px 2px 4.8px 0px var(--rgb-general-950,05)',
    '& ul': {
        maxHeight: '250px !important',
        padding: '0 !important',
        '& li': {
            '&:hover': {
                backgroundColor: 'var(--shades-100) !important',
            },
            '& > div': {
                backgroundColor: 'var(--transparent)',
            },
        },
    },
};


export const CustomList = {
    display: 'flex',
    padding: '8px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    marginTop: 0,
    marginBottom: 0,
    backgroundColor: 'var(--general-00)',
};

export const tooltipSxDefault = {
    backgroundColor: 'var(--shades-950)',
    color: 'var(--general-00)',
    px: '8px',
    py: '8px',
    borderRadius: '4px',
};

export const arrowSxDefault = {
    color: 'var(--general-00)',
};

export const CustomLevelCardStyle = (status, disabled) => {
    let borderColor = "var(--shades-400)";
    let backgroundColor = "var(--shades-100)";
    let fontColor = "var(--general-950)";

    if (!disabled) {
        switch (status) {
            case STATUS_MODEL.IN_PROGRESS:
                borderColor = "var(--secondary-400)";
                backgroundColor = "var(--secondary-50)";
                break;
            case STATUS_MODEL.PENDING:
                borderColor = "var(--shades-400)";
                backgroundColor = "var(--shades-100)";
                break;
            case STATUS_MODEL.APPROVED:
                borderColor = "var(--success-400)";
                backgroundColor = "var(--success-50)";
                break;
            case STATUS_MODEL.DENIED:
                borderColor = "var(--error-code-400)";
                backgroundColor = "var(--error-code-50)";
                break;
            case STATUS_MODEL.CHANGES_REQUESTED:
                borderColor = "var(--warning-400)";
                backgroundColor = "var(--warning-50)";
                break;
            case STATUS_MODEL.PENDING_REVIEW:
                borderColor = "var(--secondary-400)";
                backgroundColor = "var(--secondary-50)";
                break;
            case STATUS_MODEL.DRAFT:
                borderColor = "var(--secondary-400)";
                backgroundColor = "var(--secondary-50)";
                break;
        }
    }

    return {
        line: {
            width: '2px',
            height: '100%',
            backgroundColor: disabled ? "var(--shades-200)" : borderColor,
        },
        circle: {
            width: '16px',
            height: '16px',
            minWidth: '16px',
            minHeight: '16px',
            borderRadius: "50%",
            border: `3px solid ${disabled ? "var(--shades-200)" : borderColor}`,
            backgroundColor: " var(--general-00)"
        },
        container: {
            width: "100%",
            backgroundColor: disabled ? "var(--shades-50)" : "var(--transparent)",
            borderRadius: "8px",
            border: `1px solid ${disabled ? "var(--shades-200)" : borderColor}`,
        },
        levelCard: {
            backgroundColor: disabled ? "var(--shades-100)" : backgroundColor,
            padding: "16px",
            borderRadius: "8px",
            borderBottom: `1px solid ${disabled ? "var(--shades-200)" : borderColor}`,
            width: "100%",
        },
        level: {
            color: disabled ? "var(--shades-400) " : fontColor,
            fontWeight: 'var(--ibl-font-w-600)',
            fontSize: 'var(--ibl-ientry-p)'
        },
        p: {
            color: disabled ? "var(--shades-300) " : fontColor,
            fontWeight: 'var(--ibl-font-w-600)',
            fontSize: 'var(--fs-14px)'
        },
        span: {
            color: !disabled ? "var(--shades-600) " : "var(--shades-300) ",
            fontWeight: 'var(--ibl-font-w-300)',
            fontSize: 'var(--fs-14px)'
        },
        icon: {
            fill: disabled ? 'var(--shades-200)' : 'var(--shades-400)',
            color: disabled ? 'var(--shades-100)' : 'var(--shades-400)',
        },
        boxComentary: {
            display: "flex",
            height: "auto",
            minHeight: "40px",
            padding: "12px 16px",
            justifyContent: "space-between",
            alignItems: "flex-start",
            alignSelf: "stretch",
            borderRadius: "8px",
            border: "1px solid var(--shades-200)",
            background: "var(--shades-50)",
            color: "var(--general-950)",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 300,
            lineHeight: "120%",
        }
    }
};

export const CalendarChipTitleStyle = ({
    borderColor = 'var(--primary-700)',
    backgroundColor = 'var(--general-00)',
    textColor = 'var(--primary-700)',
    height = '40%',
}) => ({
    backgroundColor,
    color: textColor,
    border: `0.72px solid ${borderColor}`,
    borderBottom: 'none',
    borderRadius: '2px 2px 0px 0px',
    height,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const CalendarChipSubtitleStyle = ({
    borderColor = 'var(--primary-700)',
    backgroundColor = 'var(--primary-50)',
    textColor = 'var(--primary-700)',
    height = '60%',
}) => ({
    backgroundColor,
    color: textColor,
    border: `0.72px solid ${borderColor}`,
    borderTop: 'none',
    borderRadius: '0px 0px 2px 2px',
    height,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const CustomFieldCardStyle = (status, disabled) => {

    let borderColor = "var(--shades-400)";
    let backgroundColor = "var(--shades-100)";
    let fontColor = "var(--general-950)";
    let fontColorSubtitle = "var(--general-950)";

    if (!disabled) {
        switch (status) {
            case STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION:
                borderColor = "var(--shades-400)";
                backgroundColor = "var(--shades-50)";
                break;
            case STATUS_MODEL.APPROVED:
                borderColor = "var(--success-400)";
                backgroundColor = "var(--success-50)";
                fontColor = "var(--success-600)";
                fontColorSubtitle = "var(--success-500)";
                break;
            case STATUS_MODEL.REJECTED:
                borderColor = "var(--error-code-400)";
                backgroundColor = "var(--error-code-50)";
                fontColor = "var(--error-code-600)";
                fontColorSubtitle = "var(--error-code-500)";
                break;
            case STATUS_MODEL.CHANGES_REQUESTED:
                borderColor = "var(--warning-400)";
                backgroundColor = "var(--warning-50)";
                fontColor = "var(--warning-600)";
                fontColorSubtitle = "var(--warning-500)";
                break;
        }
    }

    return {
        line: {
            width: '2px',
            height: '100%',
            backgroundColor: disabled ? "var(--shades-200)" : borderColor,
        },
        circle: {
            width: '16px',
            height: '16px',
            minWidth: '16px',
            minHeight: '16px',
            borderRadius: "50%",
            border: `3px solid ${disabled ? "var(--shades-200)" : borderColor}`,
            backgroundColor: " var(--general-00)"
        },
        container: {
            width: "100%",
            backgroundColor: disabled ? "var(--shades-50)" : "var(--transparent)",
            borderRadius: "8px",
            border: `1px solid ${disabled ? "var(--shades-200)" : borderColor}`,
        },
        levelCard: {
            backgroundColor: disabled ? "var(--shades-100)" : backgroundColor,
            padding: "16px",
            borderRadius: "8px",
            borderBottom: `1px solid ${disabled ? "var(--shades-200)" : borderColor}`,
            width: "100%",
        },
        level: {
            color: disabled ? "var(--shades-400) " : fontColor,
            fontWeight: 'var(--ibl-font-w-600)',
            fontSize: 'var(--ibl-ientry-p)'
        },
        title: {
            color: disabled ? "var(--shades-400) " : "var(--general-950)",
            fontWeight: 'var(--ibl-font-w-600)',
            fontSize: 'var(--ibl-ientry-p)'
        },
        p: {
            color: disabled ? "var(--shades-300) " : fontColor,
            fontWeight: 'var(--ibl-font-w-300)',
            fontSize: 'var(--fs-chip)'
        },
        span: {
            color: disabled ? "var(--shades-300) " : "var(--general-950)",
            fontWeight: 'var(--ibl-font-w-300)',
            fontSize: 'var(--fs-chip)'
        },
        icon: {
            fill: disabled ? 'var(--shades-200)' : 'var(--shades-400)',
            color: disabled ? 'var(--shades-100)' : 'var(--shades-400)',
        },
    };
};


export const CustomStyleStatusCard = {
    height: '290px',
    with: '300px',
    borderRadius: '8px',
    '& .MuiCardContent-root': {
        padding: 0,
    },
}

export const ProgressBar = {
    width: '100%',
    padding: '0px !important',
    marginTop: '30px',
    'MuiMobileStepper-root ': {
        '.MuiLinearProgress-root': {
            width: '100%'
        }
    },
    '.css-xogbah': {
        width: '100%'
    },
    '.css-857cg3-MuiLinearProgress-root-MuiMobileStepper-progress': {
        width: '100%',
        background: 'var(--primary-25)',
        height: '8px',
        borderRadius: '8px'
    },
    '.css-wiypv7-MuiLinearProgress-bar1': {
        border: '1px solid var(--primary-400)',
        background: 'var(--primary-400)'
    }
}

export const CustomStylePaperNotifications = {
    position: "fixed",
    bottom: '15px',
    right: '10px',
    width: "90%",
    maxWidth: '560px',
    minWidth: '300px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 9999,
}

export const CustomDateRangePickerStyle = {
    popperContainer: (height) => {
        return {
            height: `${height}px`
        }
    },
    popperContainerScroll: (height) => {
        return {
            height: `${height}px`
        }
    },
    popper: (minWidth) => {
       return {
           minWidth: minWidth,
           zIndex: 1300,
       }
    },
    dayContainer: (backgroundColor, fontColor) => {
        return {
            width: "45px",
            height: "28px",
            borderRadius: "20px",
            backgroundColor: backgroundColor,
            color: fontColor,
            cursor: "pointer",
            transition:
                "background-color 0.2s",
            border: "none",
            outline: "none",
            boxShadow: "none",
        }
    }
}

export const CustomStepperStyles = {
    connector: {
        [`& .${stepConnectorClasses.line}`]: {
            borderTopStyle: 'dashed',
            borderTopWidth: 2,
            borderColor: 'var(--shades-700)',
        },
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
    },
    stepperContainer: {
        width: 400,
        margin: '0 auto',
    },
    stepIcon: (backgroundColor) => ({
        width: 32,
        height: 32,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: backgroundColor,
    }),
    dateText: (color) => ({
        color: color || 'var(--shades-300)',
        fontWeight: 400,
        fontSize: 8,
        mt: '-5px !important',
    }),
    statusText: (color) => ({
        color: color || 'var(--shades-300)',
        fontWeight: 400,
        fontSize: 10,
        mt: '10px !important',

        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: 1.2,
    }),
};

export const getSortableItemStyle = (transform, transition, isDragging) => ({
  transform: CSS.Transform.toString(transform),
  transition,
  opacity: isDragging ? 0.8 : 1,
  cursor: 'grab',
  userSelect: 'none',
});

export const CustomStyleDaySelector = ({ border, checked, background, text }) => ({
    '& > .days-text-style':{
        color: `${text} !important`
    },
    '& > .checkbox-container':{
        '& > article': {
            border: `1px solid ${border} !important`,
            background: `${background} !important`,

            '& > input': {
                background: `${background} !important`,
                cursor: 'initial',

                '&:checked': {
                    border: `1px solid ${checked} !important`,
                    backgroundColor: `${checked} !important`,
                },
            },
        },
    }

});

export const CustomStyleCustomCarrousel = {
  container: {
    position: 'relative',
    width: '100%',
    height: '250px',
    overflow: 'hidden',
    boxShadow: '0 4px 10px var(--shades-150)',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: '0.5s ease-in-out',
  },
  arrowLeft: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '10px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: 'var(--shades-500)',
    color: 'var(--shades-100)',
    '&:hover': {
      backgroundColor: 'var(--shades-500)',
    },
  },
  arrowRight: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    right: '10px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: 'var(--shades-500)',
    color: 'var(--shades-100)',
    '&:hover': {
      backgroundColor: 'var(--shades-500)',
    },
  },
  indicatorContainer: {
    position: 'absolute',
    bottom: '14px',
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1.2,
  },
  dot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: 'var(--shades-150)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  dotActive: {
    width: '14px',
    height: '14px',
    backgroundColor: 'var(--shades-100)',
    opacity: '1px',
  },
};

export const CustomStyleIconCircleContainer = {
    width: '40px',
    height: '40px',
    border: '1px solid var(--shades-200)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

// CustomMinimap.styles.js

export const CustomMinimapStyle = (id, params = {}) => {
    const styles = {
        container: {
            margin: 0,
            padding: "6px 10px",
            height: params.height,
            width: "160px",
            background: "var(--general-00)",
            borderRadius: "12px",
            border: "1px solid var(--shades-200)",
            boxShadow: "0 2px 5px rgba(var(--rgb-general-950), .60)",

            '& .minimap-track': {
                position: "relative",
                width: "100%",
                height: "100%",
                overflow: "hidden"
            },

            '& .minimap-column': {
                position: "absolute",
                top: 0,
                bottom: 0,
                background: "var(--shades-300)",
            },

            '& .minimap-column-highlight': {
                position: "absolute",
                top: 0,
                bottom: 0,
                background: "var(--accent-blue-400)",
                opacity: 0.4,
                cursor: "grab",
            },
        },

        column: {
            left: `${params.x}px`,
            width: `${params.width}px`,
        },

        highlight: {
            left: `${params.left}px`,
            width: `${params.width}px`,
        }
    };

    return styles[id] || {};
};
export const CustomChipAutocompleteStyles = {
    inputWrapper: (isDisabledInput, open, value = []) => {
        const chipsCount = value.length;
        const isCompact = chipsCount <= 1;
        return {
            border: open ? '2px solid var(--primary-600)' : '1px solid var(--general-950)',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            flexWrap: open ? 'wrap' : 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minHeight: '40px',
            height: isCompact ? '40px' : 'auto',
            padding: isCompact ? '6px 16px' : '12px 16px',
            gap: '6px',
            cursor: 'text',
            position: 'relative',
            transition: '0.2s border-color',
            '&:hover': {
                border: '2px solid var(--general-950)',
                lineHeight: '1.44',
            },
        };
    },
    inputDynamic: (isMaxReached) => ({
        cursor: isMaxReached ? 'default' : 'text',
        caretColor: isMaxReached ? 'transparent' : 'auto',
        pointerEvents: isMaxReached ? 'none' : 'auto',
    }),
   paper: {
        overflow: 'visible !important',
        maxHeight: 'unset !important',
        minWidth: '100%',
        marginTop: '18px',
        border: '0.6px solid var(--shades-400)',
        borderRadius: '4px',
        boxShadow: '0px 2px 4.8px 0px var(--rgb-general-950, 0.5)'
    },
    chipWrapper: {
        display: 'flex',
        alignItems: 'center',
    },

    input: {
        border: 'none',
        outline: 'none',
        flexGrow: 1,
        width: '100%',
        fontSize: '$fs-15px',
        alignSelf: 'center',
    },

    arrowIcon: (open) => ({
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        transition: '0.2s',
        cursor: 'pointer',
        color: '$shades-600',
    }),

    listbox: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'absolute',
        width: '100%',
        background: '$general-00',
        border: '1px solid $shades-400',
        borderRadius: '8px',
        maxHeight: '325px',
        overflowY: 'auto',
        zIndex: 100,
        boxShadow: '0 2px 4.8px 0 rgba($rgb-general-950, 0.50)',
        marginTop: '8px',
    },

    optionItem: {
        width: '100%',
        boxSizing: 'border-box',
        padding: '10px 14px',
        cursor: 'pointer',
        fontSize: '$fs-15px',
        fontFamily: '$primary-font',
        '&:hover': {
            backgroundColor: '$shades100',
        },
    },
};

export const CustomStyleTextFile = {
    marginBottom: '1px !important',
    width: '100%',
    ...BORDER_DEFAULT,
};

export const CustomStyleTextFileRequired = {
    marginBottom: '1px !important',
    width: '100%',
    '&:hover': ERROR_HOVER_STATE_BORDER,
    ...ERROR_BORDER_DEFAULT,
};

export const CustomButtonDropdown = {
    liContainer:{
        '&:hover, &.Mui-focusVisible, &.Mui-selected, &.Mui-selected:hover, &:focus': {
            backgroundColor: 'transparent'
        },
        paddingTop: '0 !important',
        paddingBottom: '0 !important'
    }

}

export const QrDefaultStyle = (color) => ({
    fill: color,
});

export const CustomStyleCompactTable = {
    row: (index, length) => {
        const isFirst = index === 0;
        const isLast = index === length - 1;

        return {
            border: '1px solid var(--shades-300)',
            overflow: 'hidden',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            px: 2,
            py: 1.5,
            pl: '36px',
            borderTopLeftRadius: isFirst ? '8px' : '0px',
            borderTopRightRadius: isFirst ? '8px' : '0px',
            borderBottomLeftRadius: isLast ? '8px' : '0px',
            borderBottomRightRadius: isLast ? '8px' : '0px',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: '-1px',
                width: '30px',
                backgroundColor: 'var(--success-50)',
                borderRight: '2px solid var(--success-400)'
            },

            '&:hover': {
                backgroundColor: 'var(--shades-50)',
            },
        };
    }
};

export const CustomStyleSuffixText = (disabled) => ({
    fontWeight: 'var(--ibl-font-w-700)',
    fontSize: 'var(--ibl-ientry-p)',
    color: disabled ? 'var(--shades-300)' : 'var(--general-950)',
    textTransform: 'uppercase',
});
